'use client';

import { ChevronDownIcon } from '@heroicons/react/24/outline';

type Item = { q: string; a: string };

/**
 * Accordion berbasis <details> — tetap bisa dibuka meski JavaScript gagal
 * dimuat, dan isinya ikut terbaca mesin pencari.
 */
export default function Faq({ items }: { items: Item[] }) {
  return (
    <div className="divide-y divide-gray-200 overflow-hidden rounded-2xl border border-gray-200 bg-white">
      {items.map((item) => (
        <details key={item.q} className="group">
          <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-blue-50/50 sm:px-6 sm:py-5">
            <span className="text-[15px] font-semibold text-gray-900">{item.q}</span>
            <ChevronDownIcon
              className="h-5 w-5 shrink-0 text-[#293aa1] transition-transform duration-300 group-open:rotate-180"
              aria-hidden="true"
            />
          </summary>
          <div className="px-5 pb-5 text-sm leading-relaxed text-gray-600 sm:px-6">{item.a}</div>
        </details>
      ))}
    </div>
  );
}
